export default "__VITE_ASSET__87ada0e8__"